import apiClient from '@utils/apiClient.ts';
import {
    LoginRequest,
    LoginResponse,
    SnsJoinReq,
    SnsLoginCheckRes,
    SnsLoginCheckResData,
} from './type.ts';

export const api = {
    login: async (credentials: LoginRequest): Promise<LoginResponse> => {
        const response = await apiClient.post<LoginResponse>(
            '/api/v1/login/admin',
            credentials,
        );
        return response.data;
    },

    idLogin: async (userId: string, userPw: string): Promise<LoginResponse> => {
        const response = await apiClient.post<LoginResponse>(
            '/api/v1/login/id',
            { userId: userId, userPw: userPw },
        );
        return response.data;
    },

    logout: async (): Promise<void> => {
        await apiClient.post('/logout');
    },

    refreshToken: async (): Promise<LoginResponse> => {
        const response = await apiClient.post<LoginResponse>('/refresh-token');
        return response.data;
    },

    // 필요시 추가 auth 관련 API들
    checkAuthStatus: async (): Promise<{ isValid: boolean }> => {
        const response = await apiClient.get('/auth/status');
        return response.data;
    },

    naverLogin: async (
        accessToken: string,
    ): Promise<{
        success: boolean;
        isJoined: boolean;
        snsInfo?: SnsLoginCheckRes;
        error?: string;
    }> => {
        try {
            const response = await apiClient.post<SnsLoginCheckResData>(
                '/api/v1/login/naver',
                { accessToken },
            );
            const data = response.data.data;
            if (data.isJoined && data.accessToken) {
                // 기존 로그인 처리는 authStore에서
                return { success: true, isJoined: true, snsInfo: data };
            }
            return { success: true, isJoined: false, snsInfo: data };
        } catch (e: any) {
            return { success: false, isJoined: false, error: e.message };
        }
    },

    kakaoLogin: async (
        code: string,
    ): Promise<{
        success: boolean;
        isJoined: boolean;
        snsInfo?: SnsLoginCheckRes;
        error?: string;
    }> => {
        try {
            const redirectUri = `${window.location.origin}/login`;
            const response = await apiClient.post<SnsLoginCheckResData>(
                '/api/v1/login/kakao',
                { code, redirectUri },
            );
            const data = response.data.data;
            if (data.isJoined && data.accessToken) {
                return { success: true, isJoined: true, snsInfo: data };
            }
            return { success: true, isJoined: false, snsInfo: data };
        } catch (e: any) {
            return { success: false, isJoined: false, error: e.message };
        }
    },

    googleLogin: async (
        code: string,
    ): Promise<{
        success: boolean;
        isJoined: boolean;
        snsInfo?: SnsLoginCheckRes;
        error?: string;
    }> => {
        try {
            const redirectUri = `${window.location.origin}/login`;
            const response = await apiClient.post<SnsLoginCheckResData>(
                '/api/v1/login/google',
                { code, redirectUri },
            );
            const data = response.data.data;
            if (data.isJoined && data.accessToken) {
                return { success: true, isJoined: true, snsInfo: data };
            }
            return { success: true, isJoined: false, snsInfo: data };
        } catch (e: any) {
            return { success: false, isJoined: false, error: e.message };
        }
    },

    snsJoin: async (param: SnsJoinReq): Promise<LoginResponse> => {
        const response = await apiClient.post<LoginResponse>(
            '/api/v1/login/sns/join',
            param,
        );
        return response.data;
    },
};
